import React from "react";
import { Stack, Typography } from "@mui/material";

const JoinHeader = ({ children }) => {

  if (children) {
    return <>{children}</>;
  }

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      spacing={1}>
      <Typography variant="h4">
        Create Account
      </Typography>
    </Stack>
  );
};

export default JoinHeader;